import React from "react";
import NextLink from "next/link";
import Button from "@digital-hig/mui/Button";

type LinkButtonProps = {
  href: string;
  children: React.ReactNode;
  /** Any other Digital HIG Button prop (variant, startIcon, ...). */
  [buttonProp: string]: unknown;
};

/**
 * Digital HIG Button rendered as a Next.js link: a plain click is a client-side route change (no page
 * reload), while middle/ctrl/cmd-click and "Open in new tab" work natively — the new tab borrows the
 * session from an open tab (see crossTabAuth).
 */
const LinkButton = ({ href, children, ...buttonProps }: LinkButtonProps) => (
  <Button component={NextLink} href={href} prefetch={false} {...buttonProps}>
    {children}
  </Button>
);

export default LinkButton;
